import { hubspotTogglePosition } from './style';

const useHubspot = () => {
  const hubspotElement: HTMLDivElement | null = document.querySelector(
    '#hubspot-messages-iframe-container'
  );

  const moveToRight = () => {
    if (hubspotElement) {
      hubspotElement.className = hubspotTogglePosition(false);
    }
  };

  const moveToLeft = (width: number) => {
    if (hubspotElement) {
      hubspotElement.className = hubspotTogglePosition(true, width);
    }
  };

  const hide = (hideIt: boolean) => {
    if (hubspotElement) {
      hubspotElement.style.setProperty(
        'display',
        hideIt ? 'none' : 'initial',
        'important'
      );
    }
  };

  return { moveToRight, moveToLeft, hide };
};

export default useHubspot;
